import { render, staticRenderFns } from "./cardAdd.vue?vue&type=template&id=b822e28c&scoped=true&"
import script from "./cardAdd.vue?vue&type=script&lang=js&"
export * from "./cardAdd.vue?vue&type=script&lang=js&"
import style0 from "./cardAdd.vue?vue&type=style&index=0&id=b822e28c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b822e28c",
  null
  
)

export default component.exports